import { null as zNull } from "zod";

export const disconnectMintsoftIntegration = {
  name: "disconnectMintsoftIntegration" as const,
  input: zNull(),
  output: zNull(),
};
